import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, MessageCircle, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

const YEAR = new Date().getFullYear();

const SOLUTIONS = [
  "SYNIR · Auditoria & Faturamento",
  "Wely · BI Hospitalar",
  "HUGGIN · Auditoria",
  "MUNINN · IA para glosas",
  "EIRAI · Assistente clínico IA",
  "EscalaMed · Escalas médicas",
  "Autorizações Inteligentes",
  "Assinatura Digital",
  "Anexos & Documentos",
];

const COMPANY = [
  { to: "/sobre", label: "Sobre" },
  { to: "/solucoes", label: "Soluções" },
  { to: "/blog", label: "Blog" },
  { to: "/contato", label: "Contato" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0B1220] text-gray-300 overflow-hidden"
    >
      <div className="grain absolute inset-0" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Brand block */}
          <div className="lg:col-span-4">
            <Logo variant="light" />
            <p className="mt-6 text-sm leading-relaxed text-gray-400 max-w-sm">
              Transformamos a saúde através da tecnologia. Soluções corporativas
              para hospitais, clínicas e instituições que exigem precisão,
              segurança e escala.
            </p>

            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://wa.me/5500000000000"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
                className="inline-flex items-center justify-center w-10 h-10 border border-gray-700 hover:border-[#1E3A8A] hover:bg-[#1E3A8A] transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
              </a>
              <a
                href="https://linkedin.com/company/axis-saude-digital"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="inline-flex items-center justify-center w-10 h-10 border border-gray-700 hover:border-[#1E3A8A] hover:bg-[#1E3A8A] transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="mailto:contato@axissaudedigital.com.br"
                data-testid="footer-email"
                aria-label="E-mail"
                className="inline-flex items-center justify-center w-10 h-10 border border-gray-700 hover:border-[#1E3A8A] hover:bg-[#1E3A8A] transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div className="lg:col-span-3">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500 mb-5">
              Soluções
            </p>
            <ul className="space-y-3">
              {SOLUTIONS.map((s) => (
                <li key={s}>
                  <Link
                    to="/solucoes"
                    className="text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-2">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500 mb-5">
              Empresa
            </p>
            <ul className="space-y-3">
              {COMPANY.map((c) => (
                <li key={c.to}>
                  <Link
                    to={c.to}
                    className="text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500 mb-5">
              Contato
            </p>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#1E3A8A]" />
                <a
                  href="mailto:contato@axissaudedigital.com.br"
                  className="hover:text-white transition-colors"
                >
                  contato@axissaudedigital.com.br
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#1E3A8A]" />
                <span>+55 (00) 00000-0000</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#1E3A8A]" />
                <span>Brasil · Atendimento nacional</span>
              </li>
            </ul>

            <Link
              to="/contato"
              data-testid="footer-cta-demo"
              className="mt-8 inline-flex items-center gap-2 text-sm text-white border-b border-[#1E3A8A] pb-1 hover:gap-3 transition-all"
            >
              Solicitar demonstração
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-gray-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-gray-500 font-mono-axis">
            © {YEAR} Áxis Saúde Digital. Todos os direitos reservados.
          </p>
          <p className="text-xs text-gray-500 font-mono-axis">
            LGPD compliant · ISO-oriented · Made in Brazil
          </p>
        </div>
      </div>
    </footer>
  );
}
